import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { DateTime } from "luxon";

// eslint-disable-next-line no-console
console.log(new LanguageDetector().detect());
i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(Backend)
  .init({
    debug: true,
    fallbackLng: "en",
    load: "languageOnly", // Only load language code (en) not locale (en-US)
    supportedLngs: ["en", "it"],
    nonExplicitSupportedLngs: true, // Allow en-US to fallback to en
    backend: {
      loadPath: "/locales/{{lng}}/translation.json"
    },
    detection: {
      // Convert detected language codes to supported languages
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
      convertDetectedLanguage: lng => {
        // Convert en-US, en-GB, etc. to en
        if (lng && lng.startsWith("en")) {
          return "en";
        }
        // Return the language if it's supported, otherwise return fallback
        return lng && ["en", "it"].includes(lng) ? lng : "en";
      }
    }
  });

i18next.services.formatter.add("DATETIME_MED", (value, lng) => {
  return DateTime.fromJSDate(value)
    .setLocale(lng)
    .toLocaleString(DateTime.DATETIME_MED);
});

i18next.services.formatter.add("DATE", (value, lng) => {
  return DateTime.fromJSDate(value)
    .setLocale(lng)
    .toLocaleString(DateTime.DATE_FULL);
});

i18next.services.formatter.add("TIME", (value, lng) => {
  return DateTime.fromJSDate(value)
    .setLocale(lng)
    .toLocaleString(DateTime.TIME_SIMPLE);
});
